import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { fromRejectionReasonAction } from '../actions';
import { IRejectionReason } from '../models/rejection-reason.model';

export const rejectionReasonFeatureKey = 'uploadedFileRejectionReason';

export interface StaticDataRejectionReasonState {
  loadStaticDataRejectionReason: void;
  loadStaticDataRejectionReasonResponse: IRejectionReason[];
  loadStaticDataRejectionReasonFailure: IGenericError<ErrorResponse>;
}

export const initialState: StaticDataRejectionReasonState = {
  loadStaticDataRejectionReason: undefined,
  loadStaticDataRejectionReasonResponse: undefined,
  loadStaticDataRejectionReasonFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromRejectionReasonAction.loadUploadedFileRejectionReasons, (state, action) => ({
    ...state,
    loadStaticDataRejectionReason: null
  })),

  on(fromRejectionReasonAction.loadUploadedFileRejectionReasonsSuccess, (state, action) => ({
    ...state,
    loadStaticDataRejectionReasonResponse: action.response
  })),

  on(fromRejectionReasonAction.loadUploadedFileRejectionReasonsFailure, (state, action) => ({
    ...state,
    loadStaticDataRejectionReasonFailure: action.error
  }))
);

export const getStaticDataRejectionResponse = (state: StaticDataRejectionReasonState) => state.loadStaticDataRejectionReasonResponse;
export const getStaticDataRejectionFailure = (state: StaticDataRejectionReasonState) => state.loadStaticDataRejectionReasonFailure;
